var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.688 12.375A1.69 1.69 0 010 10.687v-9A1.688 1.688 0 01.45.544C.768.2 1.22 0 1.687 0h14.624A1.69 1.69 0 0118 1.688v9a1.69 1.69 0 01-1.688 1.687H1.688zm-.563-1.688c0 .311.252.563.563.563h14.624c.311 0 .563-.252.563-.563v-8.86l-4.212 2.905L15.007 6.9a.563.563 0 01-.764.827l-2.53-2.339-1.368.945c-.395.272-.86.417-1.345.417s-.95-.144-1.345-.417l-1.369-.944-2.53 2.338a.566.566 0 01-.794-.031.564.564 0 01.03-.795l2.344-2.167-4.211-2.905v8.86zm7.17-5.282c.206.143.45.218.705.218.255 0 .499-.075.706-.218l6.207-4.28H2.087l6.207 4.28z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.02c1e13d960e244239bdaec5dadcd048.svg";
export { ForwardRef as ReactComponent };